import { lazy } from "react";

export const Clock = lazy(() => import("./clock"));
